import ApplicationAlert, { AlertType } from './domain/ApplicationAlert';
import {
  Row,
  Col,
  Label,
  Card,
  CardBody,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { isCollectionNullOrEmpty, isNullOrEmpty } from './utils';
import { useDispatch } from 'react-redux';
import AlertsActions from '../features/alerts/actions';
import slice from '../features/ingest/ingestSlice';
interface AlertsHandlerProps {
  alert: ApplicationAlert;
}

const { actions } = slice;

const renderButtons = (
  alertActions: AlertsActions,
  alert: ApplicationAlert,
) => {
  switch (alert?.type) {
    case AlertType.ERROR:
      return (
        <>
          <Button color="primary" onClick={() => alertActions.dismiss()}>
            Close
          </Button>
        </>
      );
    case AlertType.UPLOAD:
      return (
        <>
          <Button
            color="primary"
            onClick={() =>
              alertActions.downloadLogs(alert.groupId, alert.ingestId)
            }
          >
            Download logs
            {alert.loading && (
              <span style={{ paddingLeft: '1em' }}>
                <Spinner size="sm" />
              </span>
            )}
          </Button>
          <Button
            color="primary"
            tag={Link}
            to="/uploads"
            onClick={() => alertActions.goToViewUploadsPage()}
          >
            View Your Uploads
          </Button>
          <Button
            color="primary"
            onClick={() => {
              alertActions.dismissUploadSuccess();
            }}
          >
            OK
          </Button>
        </>
      );
    default:
      return (
        <Button color="primary" onClick={() => alertActions.dismiss()}>
          OK
        </Button>
      );
  }
};

const renderUploadDetails = (alert?: ApplicationAlert) => {
  return (
    <>
      <Row className="justify-content-center mb-3">
        <div>{alert?.body}</div>
      </Row>
      <Row className="mb-3">
        <div>Number of Rows Uploaded: {alert?.rowsUploaded}</div>
      </Row>
      <Row className="mb-3">
        <div>Erroneous Rows (Excluded): {alert?.rowsWithErrors}</div>
      </Row>
      <Row className="mb-3">
        <div>Potential Duplicates (Excluded): {alert?.potentialDupes}</div>
      </Row>
    </>
  );
};

export default (props: AlertsHandlerProps) => {
  const { alert } = props;
  const alertActions = new AlertsActions(useDispatch());

  return (
    <>
      <Modal isOpen={!isNullOrEmpty(alert)}>
        <ModalHeader>{alert?.header}</ModalHeader>
        <ModalBody>
          {alert?.type && alert?.type == AlertType.UPLOAD
            ? renderUploadDetails(alert)
            : alert?.body}
        </ModalBody>
        <ModalFooter style={{ padding: '1em' }}>
          {renderButtons(alertActions, alert)}
        </ModalFooter>
      </Modal>
    </>
  );
};
